import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../PortraitStage";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface FailureScanModalProps extends ModalProps {
  message?: string;
  onHide: () => void;
  redirectHomeAfterMs?: number;
}

const FailureScanModal = ({
  message,
  redirectHomeAfterMs = 5000,
  ...props
}: FailureScanModalProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/", { replace: true });
    }, redirectHomeAfterMs);

    return () => clearTimeout(timer);
  }, [navigate, redirectHomeAfterMs]);

  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="expiryErrorModal"
      backdrop="static"
    >
      <Modal.Body>
        <div className="expiryErrorIcon" aria-hidden="true">
          <span />
          <span />
        </div>
        <div className="expiryErrorMessage">
          {message || "Invalid ticket. Check ticket date & time."}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FailureScanModal;
